import { AvailabilityAppointmentTypesComponent } from 'app/components/availability-appointment-types/AvailabilityAppointmentTypesComponent'
import { useAvailabilityAppointmentTypes } from 'app/components/availability-appointment-types/useAvailabilityAppointmentTypes'

export default function AppointmentTypes() {
  const hookData = useAvailabilityAppointmentTypes()
  return <AvailabilityAppointmentTypesComponent {...hookData} />
}
